import { useState } from 'react'
import { Typography } from 'antd'
import Card from 'components/card/Card'
import Toast from 'components/toast/Toast'
import { IUseOrderCancellation, useOrderCancellation } from './hooks/useOrderCancellation'
import Errors from 'components/errors/Errors'
import Pagination from 'components/pagination/Pagination'
import OrderCancellationTable from './components/OrdersCancellationTable'
import OrderCancellationDetail from './components/OrderCancellationDetail'
import ModalOrderCancellation from './components/ModalOrderCancellation'
import { IconChecklistCircle } from '../../components/icons'

function OrderCancellationCard({ orderCancel }: { orderCancel: IUseOrderCancellation }) {
  return (
    <Card loading={orderCancel.loading} dataTestId="card_orders_list" spinnerTestId="loader_orders">
      <Card.Header className="sticky-card-header block py-2 px-4">
        <div className="flex items-center mb-4">
          <Typography.Title className="m-0 text-2xl">Konfirmasi Pembatalan</Typography.Title>
        </div>
      </Card.Header>
      <Card.Body className="mt-0">
        {orderCancel.failed ? (
          <Errors
            data-testid="error_message_orders"
            inverse={false}
            header="Mohon maaf, permintaan Anda tidak dapat diproses."
            paragraph="terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi."
            button={true}
            buttonLabel="Coba lagi"
            buttonAction={() => orderCancel.fetchData()}
          />
        ) : (
          <OrderCancellationTable
            loading={false}
            data={orderCancel.data}
            selectOrder={payload => {
              orderCancel.setSelectedOrder(payload)
            }}
          />
        )}
      </Card.Body>
      {orderCancel.totalRows > 10 && (
        <Card.Footer>
          <Pagination
            disabled={orderCancel.loading}
            setLimit={(limit: number) => {
              orderCancel.setLimit(limit)
              orderCancel.setPage(1)
            }}
            onPageChanged={(page: number) => {
              orderCancel.setPage(page)
            }}
            totalRows={orderCancel.totalRows}
            currentPage={orderCancel.page}
            limit={orderCancel.limit}
            showLimitPage={true}
          />
        </Card.Footer>
      )}
    </Card>
  )
}

function OrderCancellation() {
  const orderCancellation = useOrderCancellation()
  const [confirmPopup, setConfirmPopup] = useState(false)
  const [isApproveCancel, setIsApproveCancel] = useState(false)
  const { toast, toastContainer } = Toast()

  const handleConfirm = (isApproved: boolean) => {
    setConfirmPopup(true)
    setIsApproveCancel(isApproved)
  }

  const onAcceptOrderCancel = async () => {
    try {
      orderCancellation.setLoading(true)
      await orderCancellation.confirmOrder(isApproveCancel)
      await orderCancellation.fetchData()
      const message = isApproveCancel
        ? 'Pesanan berhasil Dibatalkan'
        : 'Pembatalan ditolak. Pesanan kembali diproses'
      toast(message, 'success', <IconChecklistCircle color="white" />)
      orderCancellation.setSelectedOrder(null)
    } catch {
      toast('Proses Gagal. Coba lagi', 'danger')
    } finally {
      setConfirmPopup(false)
      orderCancellation.setLoading(false)
    }
  }

  return (
    <div className="content-wrapper ">
      {toastContainer}
      {!orderCancellation.selectedOrder ? (
        <OrderCancellationCard orderCancel={orderCancellation} />
      ) : (
        <OrderCancellationDetail orderCancel={orderCancellation} handleConfirm={handleConfirm} />
      )}
      <ModalOrderCancellation
        loading={orderCancellation.loading}
        visibility={confirmPopup}
        isApproved={isApproveCancel}
        onCancel={() => !orderCancellation.loading && setConfirmPopup(false)}
        onAccept={onAcceptOrderCancel}
      />
    </div>
  )
}

export default OrderCancellation
